













  import { defineComponent, ref } from 'vue'
  import uuid from 'uuid-random'

  export default defineComponent({
    name: 'OneBarcodeScanner',
    components: {
      OneBarcodeScannerModal: () => import('~/components/organisms/shared/OneBarcodeScannerModal.vue'),
    },
    props: {
      scannerIcon: {
        type: String,
        required: false,
        default: '',
      },
      showSearchOnTheRight: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    setup(props) {
      const isModalShow = ref(false)
      const componentUuid = uuid()

      const toggleModal = (val: boolean) => {
        isModalShow.value = val
      }

      return {
        isModalShow,
        uuid: componentUuid,
        toggleModal,
      }
    },
  })
